<template>
  <div class="text-center">
    <!--  -->
    <v-main>
      <v-form @submit="login">
        <v-container>
          <v-row>
            <v-spacer></v-spacer>
            <v-col md="6">
              <v-card light>
                <v-card-title primary-title class="justify-center">
                  Sar Express: Inicio de Sesión
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                  <v-row>
                    <p v-if="incorrectAuth">
                      Incorrect username or password entered - please try again
                    </p>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="po_box"
                        label="Usuario"
                        outlined
                        autofocus
                        hide-details="auto"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="password"
                        label="Contraseña"
                        outlined
                        :type="'password'"
                        hide-details="auto"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-col cols="12" lg="12" sm="12">
                    <v-btn block type="submit" color="primary" height="50">
                      Iniciar sesión
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-container>
      </v-form>
    </v-main>
    <!--  -->
  </div>
</template>

<script>

export default {
  name: "login",

  //
  mounted() {
    // this.$store.state.loading = false;
    return this.$store.state.loading = false;
    
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
  },
  data() {
    return {
      po_box: "",
      password: "",
      incorrectAuth: false,
    };
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      this.$store.dispatch("auth/DO_LOGIN", {
        username: this.po_box,
        password: this.password,
      });
    },
    goTo(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style>
body {
  background-color: #f4f4f4;
}
.login {
  background-color: #fff;
  margin-top: 10%;
}
input {
  padding: 25px 10px;
}
</style>